/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(categoryId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllSubsidiaryLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetSubsidiaryLookupResponse.SubsidiaryTypes.DP_LU_SubsidiaryType',
      'GetSubsidiaryLookupResponse.SubsidiaryTypes.DP_LU_SubsidiaryStatus'
    ],
    blueprint: {
      subsidiaryTypes: [
        '$..DP_LU_SubsidiaryType',
        {
          typeId: '$..ID',
          type: '$..Type'
        }
      ],
      subsidiaryStatus: [
        '$..DP_LU_SubsidiaryStatus',
        {
          statusId: '$..ID',
          status: '$..Status'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      if (categoryId === '1' || categoryId === '3') {
        response.subsidiaryTypes = _.filter(response.subsidiaryTypes, function(type) {
          return type.typeId !== '10';
        });
      }
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
